import React from 'react';
import PropTypes from 'prop-types';
import { TITLE } from '../../../../constants/shared/CommonConstants';

export const ClassSummaryTitle = ({ subHeaderClass }) => (
    <div className={`summary-cell ${subHeaderClass}`}>
        <h2 className="title-class-summary">{TITLE.CLASS_SUMMARY}</h2>
    </div>
);

ClassSummaryTitle.defaultProps = {
    subHeaderClass: '',
};

ClassSummaryTitle.propTypes = {
    subHeaderClass: PropTypes.string,
};

export const ClassSummaryInfo = ({
    studentsCount,
    totalStudentCount,
    status,
    skill,
    showTotalStudentsCount,
}) => (
    <div className="summary-cell">
        <span className="summary-info">
            {studentsCount}
            {showTotalStudentsCount && `/${totalStudentCount}`}
        </span>
        <div className="summary-skill">
            <span>{status}</span>
            <span>{skill}</span>
        </div>
    </div>
);

ClassSummaryInfo.defaultProps = {
    totalStudentCount: 0,
    studentsCount: 0,
    skill: '',
    status: '',
    showTotalStudentsCount: true,
};

ClassSummaryInfo.propTypes = {
    studentsCount: PropTypes.number,
    status: PropTypes.string,
    totalStudentCount: PropTypes.number,
    skill: PropTypes.string,
    showTotalStudentsCount: PropTypes.bool,
};
